import axios from "axios";
import {
  ExcluirTransacciones,
  IncluirTransacciones,
} from "../models/IncluirTransacciones.model";

export const consultarTransaccionesAgrupadasCierreLote = async (
  preCupon: number
) => {
  let qs = preCupon ? `?preCupon=${preCupon}` : "";
  return axios.get(
    `api/Transacciones/ConsultarTransaccionesAgrupadasCierreLote${qs}`
  );
};

export const consultarTransaccionesDetalles = async (preCupon: number) => {
  let qs = preCupon ? `?preCupon=${preCupon}` : "";
  return axios.get(`api/Transacciones/ConsultarTransaccionesDetalles${qs}`)
  .catch(err => err);
};

export const transaccionesIncluir = async (postData: IncluirTransacciones) => {
  return axios.post("api/Transacciones/Incluir", postData);
};

export const transaccionesExcluir = async (postData: ExcluirTransacciones) => {
  return axios.post("api/Transacciones/Excluir", postData);
};

export const transaccionesIncluirTodo = async (data: any) => {
  return axios.post("api/Transacciones/IncluirTodo", data);
};

export const alertaTransaccionesVencidas = async (comercio: number) => {
  return axios.get(
    `api/Transacciones/AlertaTransaccionAVencer?comercio=${comercio}`
  );
};

export const consultarTransaccionesConDetalleMF = async (
  preCupon: number,
  vog_code: number
) => {
  let qs = preCupon ? `?preCupon=${preCupon}&vog_code=${vog_code}` : "";
  return axios.get(`api/Transacciones/ConsultarTransaccionesConDetalleMF${qs}`);
};
